import { render, staticRenderFns } from "./PgtoAprovado.vue?vue&type=template&id=747f24a0&scoped=true&"
import script from "./PgtoAprovado.vue?vue&type=script&lang=js&"
export * from "./PgtoAprovado.vue?vue&type=script&lang=js&"
import style0 from "./PgtoAprovado.vue?vue&type=style&index=0&id=747f24a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747f24a0",
  null
  
)

export default component.exports